module.exports = __webpack_public_path__ + "img/ivTest_sub55.165885cf.png";